<template>
    <div class="container let-space-1">
        <div class="card mb-2">
            <div class="card-header py-2 text-muted">
                メールテンプレート
            </div>
            <div class="card-body">
                <div class="row mb-3">
                    <div class="col-12 col-sm-4">
                        <select v-model.trim="tempId" class="form-control mb-2">
                            <option value="">-- 新規作成 --</option>
                            <option v-for="item in list" :value="item.id" :key="item.id">{{item.title_txt}}</option>
                        </select>
                        <select v-model.trim="tempType" class="form-control">
                            <option value="markdown">MarkDownメール</option>
                            <option value="text">テキストメール</option>
                        </select>
                        <small class="text-muted">※ディフォルトメールタイプ</small>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-4">
                        <small>
                            <span class="float-right text-primary">
                                <span class="px-2" @click="mailTempSave">
                                    保存
                                </span>
                                <span :class="{'text-muted':disableDelBtn}" class="px-2" @click="mailTempDel">
                                    削除
                                </span>
                            </span>
                        </small>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-4 d-flex">
                        <div class="form-group form-check mr-2">
                            <input type="checkbox" class="form-check-input" id="check-user-name" v-model="hasUserName">
                            <label class="form-check-label" for="check-user-name"><small>名前</small></label>
                        </div>
                        <div class="form-group form-check ml-2">
                            <input type="checkbox" class="form-check-input" id="check-proj-list" v-model="hasProjList" @click="toggleProj">
                            <label class="form-check-label" for="check-proj-list"><small>案件</small></label>
                        </div>
                        <div class="form-group form-check ml-2">
                            <input type="checkbox" class="form-check-input" id="check-url-btn" v-model="hasUrlBtn" @click="toggleBtnInfo">
                            <label class="form-check-label" for="check-url-btn"><small>URLボタン</small></label>
                        </div>
                    </div>
                </div>
                <div class="row collapse" id="url-btn-info">
                    <div class="col-12 col-sm-4">
                        <select v-model.trim="urlBtnTxtS" class="form-control mb-2">
                            <option value="">-- ボタン文言選択 --</option>
                            <option value="「プロメライア」へ">「プロメライア」へ</option>
                            <option value="もっと見る">もっと見る</option>
                        </select>
                        <input v-model.trim="urlBtnTxt" type="input" class="form-control mb-2" spellcheck=false placeholder="任意のボタン文言を入力してください">
                        <textarea v-model.trim="urlBtnLink" class="form-control" :rows="urlBtnLinkRows" maxlength="500" spellcheck=false placeholder="ボタンlinkを入力してください"></textarea>
                        <small class="text-muted">※default(https://tech.promeraia.com)</small>
                    </div>
                </div>
            </div>
        </div>

        <ul class="list-group list-group-cust overflow-auto collapse mb-2" id="proj-list">
            <li v-for="pj in proj" :key="pj.id" class="list-group-item px-2 py-1">
                <div class="d-flex">
                    <div class="form-group form-check mr-2">
                        <input type="checkbox" class="form-check-input" @click="selectProj(pj.id)">
                    </div>
                    <span class="text-truncate flex-fill">
                        <small>
                            <a :href="pj.proj_url" target="_blank">{{pj.proj_nm}}</a>
                        </small>
                    </span>
                </div>
                <div>
                    <small>
                        <small class="d-flex">
                            <div class="flex-fill text-truncate">
                                {{pj.us_nm}}&nbsp;/&nbsp;{{pj.us_group}}
                            </div>
                            <div calss="text-right text-nowrap">
                                {{pj.updated_at | dformatf}}
                            </div>
                        </small>
                    </small>
                </div>
            </li>
        </ul>

        <div class="card card-body pt-2 mb-2">
            <div class="row">
                <div class="col-12">
                    <div>
                        <span>Title</span>
                        <span><small>({{titleLen}}&nbsp;/&nbsp;500)</small></span>
                    </div>
                    <textarea v-model.trim="title" class="form-control" :rows="titleRows"  spellcheck=false  maxlength="500"></textarea>
                </div>
            </div>
        </div>
        <div class="card card-body pt-2 mb-2">
            <div class="row">
                <div class="col-12">
                    <div>
                        <span>Header</span>
                        <span><small>({{headerLen}}&nbsp;/&nbsp;2000)</small></span>
                    </div>
                    <textarea v-model.trim="header" class="form-control" :rows="headerRows"  spellcheck=false  maxlength="2000"></textarea>
                </div>
            </div>
        </div>
        <div class="card card-body pt-2 mb-2">
            <div class="row">
                <div class="col-12">
                    <div>
                        <span>Body</span>
                        <span><small>({{bodyLen}}&nbsp;/&nbsp;2000)</small></span>
                    </div>
                    <textarea v-model.trim="body" class="form-control" :rows="bodyRows"  spellcheck=false  maxlength="2000"></textarea>
                </div>
            </div>
        </div>
        <div class="card card-body pt-2 mb-2">
            <div class="row">
                <div class="col-12">
                    <div>
                        <span>Footer</span>
                        <span><small>({{footerLen}}&nbsp;/&nbsp;2000)</small></span>
                    </div>
                    <textarea v-model.trim="footer" class="form-control" :rows="footerRows"  spellcheck=false  maxlength="2000"></textarea>
                </div>
            </div>
        </div>

        <!-- 履歴書upload -->
        <div class="card card-body pt-2 mb-2">
            <div class="row">
                <div class="col-12 col-sm-6">
                    <file-upload ref="file" lab="添付ファイル" :ext="['*']" :required="false" :size="2"></file-upload>
                </div>
            </div>
        </div>

        <div class="card mb-2 mt-2">
            <div class="card-body">
                <div class="row form-group justify-content-center mb-0">
                    <div class="col-sm-3">
                        <button class="btn btn-danger btn-block btn-lg" :disabled="disableSendBtn" @click="sysMailSend">
                            <i class="fas fa-paper-plane"></i>&nbsp;送信する
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FileUpload from 'pages/commons/form/File'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            FileUpload
        },
        props: {
            list: Array,
            proj: Array
        },
        data () {
            return {
                titleRows: 2,
                headerRows: 2,
                bodyRows: 2,
                urlBtnLinkRows: 2,
                footerRows: 2,
                tempType: 'markdown',
                tempId: '',
                title: '',
                header: '',
                body: '',
                urlBtnTxtS: '',
                urlBtnTxt: '',
                urlBtnLink: '',
                footer: '',
                // メッセージ用
                lev: 1,
                msg: "",
                // メールoption
                hasUserName: false,
                hasUrlBtn: false,
                hasProjList: false,
                // 案件
                selectedProj:[]
            }
        },
        watch: {
            title (val) {
                this.titleRows = this.countRow(val)
            },
            header (val) {
                this.headerRows = this.countRow(val)
            },
            body (val) {
                this.bodyRows = this.countRow(val)
            },
            urlBtnLink (val) {
                this.urlBtnLinkRows = this.countRow(val)
            },
            footer (val) {
                this.footerRows = this.countRow(val)
            },
            urlBtnTxtS (val) {
                this.urlBtnTxt = val
            },
            tempId (val) {
                if (val != '') {
                    let tmp = this.list.find(el => el.id == val)
                    this.tempType = tmp.temp_type
                    this.title = tmp.title_txt
                    this.header = tmp.header_txt
                    this.body = tmp.body_txt
                    this.footer = tmp.footer_txt
                } else {
                    this.tempType = 'markdown'
                    this.title = ''
                    this.header = ''
                    this.body = ''
                    this.footer = ''
                }
            },
            getMailTempSaveStatus (status) {
                if (status == 1) {
                    this.$store.dispatch('startSpinner')
                }
                if (status == 2) {
                    this.tempId = this.getMailTempSave.id
                    this.openMsg(0, '保存しました。')
                    this.$store.dispatch('doneSpinner')
                }
                if (status == 3) {
                    this.$store.dispatch('doneSpinner')
                }
            },
            getMailTempDelStatus (status) {
                if (status == 1) {
                    this.$store.dispatch('startSpinner')
                }
                if (status == 2) {
                    this.tempId = ''
                    this.$store.dispatch('doneSpinner')
                }
                if (status == 3) {
                    this.$store.dispatch('doneSpinner')
                }
            },
            getSysMailSendStatus (status) {
                if (status == 1) {
                    this.$store.dispatch('startSpinner')
                }
                if (status == 2) {
                    if (this.getSysMailSendCnt == 0) {
                        this.openMsg(1, '送信メンバーがありません。')
                    } else {
                        this.openMsg(0, this.getSysMailSendCnt +  '件、送信しました。')
                    }
                    this.$store.dispatch('doneSpinner')
                }
                if (status == 3) {
                    this.$store.dispatch('doneSpinner')
                }
            }
        },
        computed: {
            disableSendBtn () {
                let tempFlg = this.tempId == '' ? true : false
                let projFlg = false
                if (this.hasProjList) {
                    projFlg = this.selectedProj.length == 0 ? true : false
                }
                let btnFlg = false
                if (this.hasUrlBtn) {
                    projFlg = this.urlBtnTxt == '' ? true : false
                }
                return tempFlg || projFlg || btnFlg
            },
            disableDelBtn () {
                return this.tempId == '' ? true : false
            },
            titleLen () {
                return this.title == null ? 0 : this.title.length
            },
            headerLen () {
                return this.header == null ? 0 : this.header.length
            },
            bodyLen () {
                return this.body == null ? 0 : this.body.length
            },
            footerLen () {
                return this.footer == null ? 0 : this.footer.length
            },
            ...mapGetters([
                'getSysMailSendCnt',
                'getSysMailSendStatus',
                'getMailTempDelStatus',
                'getMailTempSaveStatus',
                'getMailTempSave'
            ])
        },
        methods: {
            getMailTemp () {
                return {
                    'tempType':this.tempType,
                    'title': this.title,
                    'header': this.header,
                    'body': this.body,
                    'footer': this.footer,
                    'hasUserName': this.hasUserName,
                    'hasProjList': this.hasProjList,
                    'selectedProj': this.selectedProj,
                    'hasUrlBtn': this.hasUrlBtn,
                    'urlBtnTxt': this.urlBtnTxt,
                    'urlBtnLink': this.urlBtnLink,
                }
            },
            getFile () {
                return this.$refs.file.getFile()
            },
            sysMailSend () {
                this.$parent.sysMailSend()
            },
            selectProj (id) {
                let idx = this.selectedProj.findIndex((item)=>item == id)
                if (idx != -1) {
                    this.selectedProj.splice(idx, 1)
                } else {
                    this.selectedProj.push(id)
                }
            },
            toggleProj () {
                if ($('#proj-list').hasClass('show')) {
                    $('#proj-list').collapse('hide')
                } else {
                    $('#proj-list').collapse('show')
                }
            },
            toggleBtnInfo () {
                if ($('#url-btn-info').hasClass('show')) {
                    $('#url-btn-info').collapse('hide')
                } else {
                    $('#url-btn-info').collapse('show')
                }
            },
            countRow (txt) {
                let num = null
                if (txt) {
                    num = txt.match(/\r\n|\n/g)
                }
                return num != null ? num.length + 2 : 2
            },
            mailTempSave () {
                if (this.doCheck()) {
                    this.$store.dispatch('mailTempSave', {
                        tempType: this.tempType,
                        tempId: this.tempId,
                        title: this.title,
                        header: this.header,
                        body: this.body,
                        footer: this.footer
                    })
                }
            },
            mailTempDel () {
                if (!this.disableDelBtn) {
                    this.openMsg(2, 'テンプレートを削除しますか？', 'tempDel', this.tempId)
                }
            },
            doCheck () {
                if (this.tempId == '') {
                    if (this.title == '') {
                        this.openMsg(1, "タイトルを入力ください。")
                        return false
                    }

                    let idx = this.list.findIndex(el => el.title_txt == this.title)
                    if (idx != -1) {
                        this.openMsg(1, "タイトルは既に存在しています。")
                        return false
                    }
                }
                return true
            },
            openMsg (lev, msg, key='', id='') {
                this.$parent.openMsg(lev, msg, key, id)
            },
            setFileMsg (data) {
                this.openMsg(data.lev, data.msg)
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .list-group-cust
        max-height: 245px;
</style>
